import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Logo from "../../../icons/Logo";
import { Button } from "../../../shadcn/components/ui/button";
import SpinLoader from "../SpinLoader";
import { useDispatch, useSelector } from "react-redux";
import { clearBuyerAuth } from "store";
import { DateTime } from "luxon";

export default function BuyerValidationWrapper(props: any) {
  const [userAccessValid, setUserAccessValid] = useState("loading");
  const router = useRouter();
  const dispatch = useDispatch();
  const getISTDate = () => {
    return DateTime.now().setZone("Asia/Kolkata").toFormat("yyyy-MM-dd");
  };
  const is2FAVerifiedForToday = (verified2faDate: any) => {
    return verified2faDate === getISTDate();
  };

  const { user, accessToken, accessType, loginDate } = useSelector(
    (state: any) => state.buyerAuth,
  );
  // console.log("user: ", user, loginDate);

  const init = async () => {
    if (!router.isReady) {
      return;
    }
    const pathname = router.pathname ?? "";

    // Keep login page accessible when user is not authenticated.
    if (!accessToken) {
      if (pathname !== "/login") {
        dispatch(clearBuyerAuth());
        router.replace("/login");
      }
      setUserAccessValid("valid");
      return;
    }
    if (loginDate) {
      const isVerified = is2FAVerifiedForToday(loginDate);
      if (!isVerified) {
        dispatch(clearBuyerAuth());
        router.replace("/login");
        setUserAccessValid("valid");
        return;
      }
    }
    if (user) {
      console.log("user not found", user);
    }
    // If access type exists and is not buyer, block access.
    if (accessType && accessType !== "buyer") {
      setUserAccessValid("invalid");
      return;
    }
    setUserAccessValid("valid");
  };

  useEffect(() => {
    if (!router.isReady) {
      return;
    }
    (async () => {
      await init();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken, accessType, router.pathname, router.isReady]);

  if (userAccessValid === "loading") {
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-[#F8F8F8] px-4 py-8">
        <SpinLoader />
      </div>
    );
  }
  if (userAccessValid === "invalid") {
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-[#F8F8F8] px-4 py-8">
        <div className="w-full max-w-2xl rounded-lg border border-[#F4D4CF] bg-brand-lightPink shadow-sm">
          <div className="flex flex-col items-center px-6 py-7">
            <div className="inline-block mb-5 tracking-wider">
              <Logo />
            </div>
            <div className="inline-flex items-center rounded-full bg-[#FFF3F3] px-3 py-1 text-[11px] font-semibold text-[#B60100]">
              Access Restricted
            </div>
            <h1 className="mt-4 text-xl text-center font-semibold text-brand-textBlack">
              Invalid access type
            </h1>
            <div className="mt-2 text-center text-sm text-brand-textGrey">
              You are trying to access a portal that is not assigned to your
              account. Please verify your access type and sign in again.
            </div>
            <div className="mt-6 w-full">
              <Button
                className="w-full"
                onClick={() => {
                  dispatch(clearBuyerAuth());
                  router.replace("/login");
                }}
              >
                Logout
              </Button>
            </div>
          </div>
          <div className="border-t border-[#F2F2F2] px-6 py-3 text-center text-xs text-brand-textLightGrey">
            If this is unexpected, contact support.
          </div>
        </div>
      </div>
    );
  }

  if (userAccessValid === "valid") {
    return props.children;
  }

  return null;
}
